import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './BottomButton.module.css';

export default function BottomButton({
  text,
  isEnabled,
  onClick,
  type = 'primary',
  shineEffect = false,
}) {
  const className = clsx(
    shineEffect ? styles.button : null,
    'flex-1 w-full py-3 px-3 font-semibold text-sm rounded-lg transition-all select-none',
    'focus-visible:outline-none focus-visible:ring-offset-2 focus-visible:ring-event-accent/50',
    {
      // PRIMARY BUTTON
      ['bg-event-accent text-event-text hover:bg-event-accent/90 active:bg-event-accent/80']:
        type === 'primary',

      // SECONDARY BUTTON
      ['bg-event-deep text-event-text hover:bg-event-deep/90 active:bg-event-deep/80']:
        type === 'secondary',
    },
  );

  return (
    <button
      onClick={onClick}
      disabled={!isEnabled}
      className={className}
      id="mainButton"
    >
      {text}
    </button>
  );
}

PropTypes.BottomButton = {
  text: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['primary', 'secondary']),
};
